import Cookies from 'universal-cookie';

// reuse the same Cookies object
window.cookiesInstance =
  window.cookiesInstance || window.parent?.cookiesInstance || new Cookies();
const cookies = window.cookiesInstance;

export function setCookie(name, value, options = {}) {
  cookies.set(name, JSON.stringify(value), {
    httpOnly: false,
    sameSite: 'lax',
    secure: process.env.NODE_ENV !== 'development',
    ...options,
  });
}

export function getCookie(name) {
  const value = cookies.get(name);
  try {
    return JSON.parse(value);
  } catch (err) {
    return value;
  }
}
